import React from 'react';

// Centered section heading with optional subtitle and content (e.g. filters).
const SectionHeading = ({ title, subtitle, children }) => (
  <div className="text-center mb-6 md:mb-10 mt-4 md:mt-6">
    <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">{title}</h3>
    {subtitle && (
      <p className="text-base text-gray-600 max-w-2xl mx-auto">{subtitle}</p>
    )}
    {children}
  </div>
);

export default SectionHeading;
